export default __webpack_public_path__ + "0a808658d8d646bbda894cfe411e3abd.png";